import type { GatsbyBrowser } from "gatsby"

const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({ pathname, prevRouterProps }) =>
  !(prevRouterProps?.location.pathname.startsWith("/products/lining/") && pathname.startsWith("/products/lining/"))

export default shouldUpdateScroll
